import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import Img from "@/components/Img";

export function formatDate(iso, lang) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(lang === "ar" ? "ar-AE" : "en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export default function PostCard({ post, featured = false }) {
  const { t, L, lang } = useLang();

  return (
    <Link
      to={`/news/${post.slug}`}
      data-testid={`post-card-${post.slug}`}
      className={`group flex h-full flex-col overflow-hidden border border-border bg-card/40 card-lift ${featured ? "md:flex-row" : ""}`}
      style={{ borderRadius: "var(--radius)" }}
    >
      <div className={`relative overflow-hidden ${featured ? "h-56 md:h-auto md:w-1/2" : "h-48"}`}>
        <Img
          src={post.image}
          width={featured ? 960 : 640}
          sizes={featured ? "(max-width: 768px) 100vw, 50vw" : "(max-width: 768px) 100vw, 33vw"}
          alt={L(post.title)}
          className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent" />
        <span className="absolute top-4 start-4 rounded-full bg-background/80 px-3 py-1 text-[10px] font-semibold tracking-[0.18em] uppercase text-primary backdrop-blur-sm">
          {t(`cat_${post.category}`)}
        </span>
        {post.featured && (
          <span className="absolute top-4 end-4 rounded-full bg-primary px-3 py-1 text-[10px] font-bold tracking-[0.18em] uppercase text-primary-foreground">
            {t("news_featured")}
          </span>
        )}
      </div>

      <div className={`flex flex-1 flex-col p-6 ${featured ? "md:p-10" : "md:p-7"}`}>
        <p className="text-xs text-muted-foreground" data-testid={`post-date-${post.slug}`}>
          {formatDate(post.date, lang)}
        </p>
        <h3 className={`mt-3 font-head leading-tight ${featured ? "text-3xl md:text-4xl" : "text-2xl"}`}>
          {L(post.title)}
        </h3>
        <p className={`mt-4 text-sm text-muted-foreground leading-relaxed ${featured ? "" : "line-clamp-3"}`}>
          {L(post.excerpt)}
        </p>
        <span className="mt-6 inline-flex items-center gap-2 text-xs font-semibold tracking-[0.15em] uppercase text-primary">
          {t("news_read")}
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1 rtl:rotate-180 rtl:group-hover:-translate-x-1" />
        </span>
      </div>
    </Link>
  );
}
